import { FIELDS } from '../../partials/Form/Form.types';
import {
  DataDirector,
  LiabilityFormData,
  LiabilityRequestData,
  LiabilityTypeBuilder,
  LiabilityTypeLabelBuilder,
} from './types';

export class CommonType implements DataDirector {
  protected resultBuilder: LiabilityTypeBuilder;
  protected labelBuilder: LiabilityTypeLabelBuilder;

  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    this.resultBuilder = builder;
    this.labelBuilder = labelBuilder;
  }

  public prepareData(expenditure: LiabilityFormData) {
    this.resultBuilder.formData = expenditure;
    const allowedFieldValueSetters = new Map<FIELDS, () => void>([
      [FIELDS.LIABILITY_TYPE, this.resultBuilder.setType.bind(this.resultBuilder)],
      [FIELDS.LIABILITY_AMOUNT, this.resultBuilder.setAmount.bind(this.resultBuilder)],
      [FIELDS.LIABILITY_COMMITMENT_END_DATE, this.resultBuilder.setCommitmentEnd.bind(this.resultBuilder)],
      [FIELDS.LIABILITY_CREDIT_CARD_BALANCE, this.resultBuilder.setCreditCardBalance.bind(this.resultBuilder)],
      [
        FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES,
        this.resultBuilder.setIsClearedBeforeLoanCompletes.bind(this.resultBuilder),
      ],
    ]);
    const allowedFields = this.getAllowedFields();

    allowedFields.forEach((allowedField) => {
      const setter = allowedFieldValueSetters.get(allowedField);
      if (setter) {
        setter();
      }
    });
  }

  getData(): LiabilityRequestData {
    return this.resultBuilder.getData();
  }

  getAllowedFields() {
    return [FIELDS.LIABILITY_TYPE];
  }

  getTitle(field: keyof LiabilityFormData) {
    return this.labelBuilder.getLabel(field);
  }
}

export class CreditCard extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setCreditCardBalance('Credit/Store card Balance');
    labelBuilder.setIsClearedBeforeLoanCompletes('Cleared before loan completes');
  }

  getAllowedFields() {
    return super
      .getAllowedFields()
      .concat([FIELDS.LIABILITY_CREDIT_CARD_BALANCE, FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES]);
  }
}

export class UnsecuredLoan extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setAmount('Unsecured loan payment');
    labelBuilder.setCommitmentEnd('Unsecured loan end date');
  }

  getAllowedFields() {
    return super.getAllowedFields().concat([FIELDS.LIABILITY_AMOUNT, FIELDS.LIABILITY_COMMITMENT_END_DATE]);
  }
}

export class StudentsLoan extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setAmount('Student Loan payment');
    labelBuilder.setCommitmentEnd('Student Loan end date');
  }

  getAllowedFields() {
    return super.getAllowedFields().concat([FIELDS.LIABILITY_AMOUNT, FIELDS.LIABILITY_COMMITMENT_END_DATE]);
  }
}

export class Other extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setAmount('Other payment');
    labelBuilder.setCommitmentEnd('Other payment end date');
  }
  getAllowedFields() {
    return super.getAllowedFields().concat([FIELDS.LIABILITY_AMOUNT, FIELDS.LIABILITY_COMMITMENT_END_DATE]);
  }
}

export class PensionContribution extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setAmount('Pension payment');
    labelBuilder.setCommitmentEnd('Pension end date ');
  }
  getAllowedFields() {
    return super.getAllowedFields().concat([FIELDS.LIABILITY_AMOUNT, FIELDS.LIABILITY_COMMITMENT_END_DATE]);
  }
}

export class BuyToLetMortgage extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setAmount('BTL mortgage payment');
  }
  getAllowedFields() {
    return super.getAllowedFields().concat([FIELDS.LIABILITY_AMOUNT]);
  }
}

export class MaintenancePayments extends CommonType {
  constructor(builder: LiabilityTypeBuilder, labelBuilder: LiabilityTypeLabelBuilder) {
    super(builder, labelBuilder);
    labelBuilder.setAmount('Maintenance  payment');
    labelBuilder.setCommitmentEnd('Maintenance payment end date');
  }
  getAllowedFields() {
    return super.getAllowedFields().concat([FIELDS.LIABILITY_AMOUNT, FIELDS.LIABILITY_COMMITMENT_END_DATE]);
  }
}
